import { render, staticRenderFns } from "./PackAnalyze.vue?vue&type=template&id=0ca4d382&"
import script from "./PackAnalyze.vue?vue&type=script&lang=js&"
export * from "./PackAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./PackAnalyze.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports